export const WadiStyles = {
    dashboard:{
        background:{
            backgroundColor:'white',
            height:'100%',
        },
        defaultFont:{
            // we will have to get them to send us their fonts
            fontFamily:'Arial',
            fontWeight:'400',
            fontSize:'15pt',
            letterSpacing:'0',
            fontColor:'#52693a',
        },
        centeredTitleBox:{
            // we will have to get them to send us their fonts
            fontFamily:'Arial',
            fontWeight:'400',
            fontSize:'15pt',
            letterSpacing:'0',
            fontColor:'#52693a',
            display:'flex', 
            alignItems:'centered', 
            justifyContent:'center',
            background:'white', 
            borderRadius:'10px', 
            paddingTop:'40px',
            paddingBottom:'10px',
            opacity:'100%'
        },
        centeredBodyBox:{
            // we will have to get them to send us their fonts
            fontFamily:'Arial',
            fontWeight:'400',
            fontSize:'10pt',
            letterSpacing:'0',
            fontColor:'#52693a',
            display:'flex', 
            alignItems:'centered', 
            justifyContent:'center',
            background:'white', 
            borderRadius:'10px', 
            paddingTop:'40px',
            paddingBottom:'10px',
            opacity:'100%'
        },
        buttonCircle:{
            borderColor:'#cfd6c1',
            borderRadius:'20px',
            width:'3vw',
            backgroundColor:'#cfd6c1',
            color:'#4e6437', 
            fontWeight:'bolder',
            fontSize:'2vh',
            marginRight:'1vw',
            marginLeft:'1vw',
        },
        button:{
            borderColor:'#cfd6c1',
            backgroundColor:'#cfd6c1',
            color:'#4e6437', 
            fontWeight:'bolder',
            fontSize:'2vh',
            marginRight:'1vw',
            marginLeft:'1vw',
        },
        buttonMedium:{
            borderColor:'#cfd6c1',
            backgroundColor:'#cfd6c1',
            color:'#4e6437', 
            fontWeight:'bolder',
            fontSize:'2vh',
            marginRight:'1vw',
            marginLeft:'1vw',
            width:'2vw'
        },
        buttonHeader:{
            borderRadius:'0px',
            borderColor:'#4b1c37',
            width:'8vw'
        },
        formFields:{
            borderRadius:'0px',
            borderColor:'#50505a',
            zIndex: 0,
        },
        dropdown:{
            borderRadius:'10px',
            backgroundColor:'#cfd6c1',
            width:'8vw',
            color:'#4e6437', 
            fontWeight:'bolder',
            fontSize:'2vh'
        },
        card:{
            borderRadius:'10px',
            backgroundColor:'#c1b1b3',
            color:'#170811', 
            fontWeight:'bold',
            fontSize:'2vh',
            cursor:'pointer'
        },

        cardForm:{
            borderRadius:'10px',
            backgroundColor:'#c1b1b3',
            color:'#170811', 
            fontWeight:'normal',
            fontSize:'2vh',
            cursor:'pointer'
        },
        cardOnClick:{
            borderRadius:'10px',
            borderColor:'#170811',
            boxShadow:'0px 5px 20px #4b1c37',
            backgroundColor:'#c1b1b3',
            color:'#170811', 
            fontWeight:'bold',
            fontSize:'2vh',
            cursor:'pointer'
        },
        dropdownBody:{
            borderRadius:'10px',
            backgroundColor:'#cfd6c1',
            width:'8vw',
            color:'#4e6437', 
            fontWeight:'bolder',
            fontSize:'2vh'
        },
        dropdownHeader:{
            borderRadius:'0px',
            borderColor:'#4b1c37',
    
        }

    }
}